class ShortcutManager {
  constructor() {
    this.shortcuts = new Map();
    this.isListening = false;
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  register(key, callback, context = 'global') {
    const shortcutKey = `${context}:${key}`;
    this.shortcuts.set(shortcutKey, callback);
  }

  unregister(key, context = 'global') {
    const shortcutKey = `${context}:${key}`;
    this.shortcuts.delete(shortcutKey);
  }

  unregisterContext(context) {
    for (const [key] of this.shortcuts) {
      if (key.startsWith(`${context}:`)) {
        this.shortcuts.delete(key);
      }
    }
  }

  handleKeyDown(e) {
    // Skip if modal is open
    if (document.querySelector('.swal2-container')) {
      return;
    }
    
    // Allow '/' and 'Escape' keys to work even when input is focused
    const isInputFocused = e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA';
    if (isInputFocused && e.key !== '/' && e.key !== 'Escape') {
      return;
    }

    // Skip modifier keys
    if (['Shift', 'Control', 'Alt', 'Meta'].includes(e.key)) {
      return;
    }

    const keyToMatch = this.normalizeKey(e);
    
    // Try to find and execute shortcut
    const contexts = ['pos', 'cart', 'global']; // Priority order
    for (const context of contexts) {
      const shortcutKey = `${context}:${keyToMatch}`;
      const callback = this.shortcuts.get(shortcutKey);
      if (callback) {
        e.preventDefault();
        const result = callback(e);
        // If callback returns true, stop processing other shortcuts
        if (result === true) {
          return;
        }
        // If callback doesn't return false, also stop processing
        if (result !== false) {
          return;
        }
      }
    }
  }

  normalizeKey(e) {
    // Handle numpad keys
    if (e.code && e.code.startsWith('Numpad')) {
      const numpadNumber = e.code.replace('Numpad', '');
      return e.shiftKey ? `Shift+${numpadNumber}` : numpadNumber;
    }
    
    // Handle regular number keys with shift
    if (e.shiftKey && ['!','@','#','$','%','^','&','*','(',')'].includes(e.key)) {
      const reverseShiftMap = {'!':'1','@':'2','#':'3','$':'4','%':'5','^':'6','&':'7','*':'8','(':'9',')':'0'};
      const number = reverseShiftMap[e.key];
      return `Shift+${number}`;
    }
    
    // Handle Alt combinations
    if (e.altKey) {
      return `Alt+${e.key.toLowerCase()}`;
    }
    
    return e.key;
  }

  startListening() {
    if (!this.isListening) {
      window.addEventListener('keydown', this.handleKeyDown);
      this.isListening = true;
    }
  }

  stopListening() {
    if (this.isListening) {
      window.removeEventListener('keydown', this.handleKeyDown);
      this.isListening = false;
    }
  }

  clear() {
    this.shortcuts.clear();
  }
}

// Create singleton instance
const shortcutManager = new ShortcutManager();

export default shortcutManager;